import { createSlice } from '@reduxjs/toolkit';
import { m } from "../../utils/date"

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 1,
    }
};

const machineSlice = createSlice({
    
    name: 'machine',
    initialState,
    reducers: {
        funGetMachine(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( machine ) => {
                return{
                    ...machine,
                    setupDt: m.date({ value: machine.setupDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const machineActions = machineSlice.actions;
export default machineSlice.reducer;